module.exports = __webpack_public_path__ + "static/img/3.dd097d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/3.jpg
// module id = JADW
// module chunks = 1